import {
	Button,
	TextField
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { useEffect, useState } from 'react';
import { useActions } from 'kea';

import grouplogic from 'src/store/group';

const EditDialog = props => {
	const [open, setOpen] = useState(false);
	const [newGroup, setNewGroup] = useState(props.group);

	const { updateName } = useActions(grouplogic);


	useEffect(() => {
		setNewGroup(props.group)
	}, [props.group])

	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
		// setNewGroup(empty_group);
	}

	const handleUpdate = () => {
		if (newGroup.name) {
			updateName(newGroup);
			// setNewGroup(empty_group);
			setOpen(false);
		}
	}

	const handleChange = (key, value) => {
		let changed_user = { ...newGroup };
		changed_user[key] = value;
		setNewGroup(changed_user);
	}

	return (
		<div>
			<Button
				color="primary"
				variant="contained"
				aria-label="add"
				onClick={handleClickOpen}
				size='large'
			>
				Edit
			</Button>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					Edit a Group
				</DialogTitle>
				<DialogContent>
					<TextField
						margin="dense"
						label="Group Name"
						type="text"
						fullWidth
						error={newGroup.name ? false : true}
						helperText={newGroup.name ? null : 'Invalid'}
						value={newGroup.name}
						onChange={(e) => handleChange('name', e.target.value)}
						inputProps={{
							maxLength: 100
						}}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleUpdate} color="primary">
						Update
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}


export default EditDialog
